/**
 * bug: 当使用GroundPrimitives时候，并且geometryInstances为数组的时候，贴地面颜色渲染会出错
 */

import geoInfo from "./list.json"
function createPolygonGeometry(polygonHierarchy, color) {

    var polygonGeometry = new Cesium.PolygonGeometry({
        polygonHierarchy: new Cesium.PolygonHierarchy(polygonHierarchy),
    });

    var geometryInstance = new Cesium.GeometryInstance({
        geometry: polygonGeometry,
        attributes: {
            color: Cesium.ColorGeometryInstanceAttribute.fromColor(color),
        },
    });

    return geometryInstance;
}

export function drawHexagon() {

    let geoInfoCollection = geoInfo.geoInfoCollection;
    var hexagonInstances = [];

    for (let geoInfo of geoInfoCollection) {

        let color = Cesium.Color.fromRandom();


        // viewer.scene.groundPrimitives.add(
        //     new Cesium.GroundPrimitive({
        //         geometryInstances: new Cesium.GeometryInstance({
        //             geometry: new Cesium.PolygonGeometry({
        //                 polygonHierarchy: new Cesium.PolygonHierarchy(geoInfo.cartesian3Data),
        //             }),
        //             attributes: {
        //                 color: Cesium.ColorGeometryInstanceAttribute.fromColor(color),
        //             },
        //         }),
        //         classificationType: Cesium.ClassificationType.TERRAIN,
        //     })
        // );

        var geometryInstances = createPolygonGeometry(geoInfo.cartesian3Data, color);
        // viewer.scene.groundPrimitives.add(
        //     new Cesium.GroundPrimitive({
        //         geometryInstances: geometryInstances,
        //         classificationType: Cesium.ClassificationType.TERRAIN,
        //     })
        // );

        viewer.scene.primitives.add(
            new Cesium.Primitive({
                geometryInstances: geometryInstances,
                appearance: new Cesium.PerInstanceColorAppearance({
                    aboveGround: true,
                    renderState: {
                        depthTest: {
                            enabled: false,
                            func: Cesium.DepthFunction.LESS
                        },
                        depthMask: false,
                    }
                })
            })
        );

    }


    // viewer.scene.groundPrimitives.add(
    //     new Cesium.GroundPrimitive({
    //         geometryInstances: hexagonInstances,
    //         classificationType: Cesium.ClassificationType.TERRAIN,
    //     })
    // );


    viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(121.12919897983933, 25.520186822745632, 1000.0)
    });

}

export function drawHexagonOutline() {


    let geoInfoCollection = geoInfo.geoInfoCollection;

    let hexagonOutline = []; //六角格边集合
    for (let geoInfo of geoInfoCollection) {
        hexagonOutline.push(new Cesium.GeometryInstance({
            geometry: new Cesium.GroundPolylineGeometry({
                positions: geoInfo.cartesian3Data,
                width: 1
            })
        }))
    }

    viewer.scene.groundPrimitives.add(new Cesium.GroundPolylinePrimitive({
        geometryInstances: hexagonOutline, //合并
        interleave: true,
        allowPicking: false,
        //某些外观允许每个几何图形实例分别指定某个属性，例如：
        appearance: new Cesium.PolylineMaterialAppearance({
            material: new Cesium.Material({
                fabric: {
                    type: 'Color',
                    uniforms: {
                        color: this.config.showSatelliteImage ? Cesium.Color.WHITE.withAlpha(0.5) : Cesium.Color.GREY.withAlpha(0.5)
                    }
                }
            })
        })
    }), 0);
}